import React, { useState, useEffect } from 'react';
import {Link} from 'react-router-dom';
import Masonry, {ResponsiveMasonry} from 'react-responsive-masonry';

import Img1 from '../../assets/img1.jpg';
import Img2 from '../../assets/img2.jpg';
import Img3 from '../../assets/img3.jpg';
import Img4 from '../../assets/img4.jpg';
import Img5 from '../../assets/img5.jpg';
import Img6 from '../../assets/img6.jpg';


import './galllery.css';


import {MdNavigateNext, MdClose} from 'react-icons/md';
import {RiArrowLeftSLine} from 'react-icons/ri';
import { IconContext } from 'react-icons';
 
const images = [
    Img1,
    Img2,
    Img3,
    Img4,
    Img5,
    Img6
]


const GalleryPostoFriederichs = () => {

    const [data, setData] = useState({img: '', i: 0})  

 const viewImage = (img, i)=>{
         console.log("Abrindo imagem:", img); // DEBUG
 
            setData({img, i})
     }
 
     const imgAction = (action) => {
         let i = data.i;
         if(action === 'next-img'){
             const nextIndex = (i + 1) % images.length; // Volta para a primeira após a última
 
             setData({ img: images[nextIndex], i: nextIndex });
         }
         if(action === 'previous-img'){
             const prevIndex = (i - 1 + images.length) % images.length; // Vai para a última ao voltar da primeira
 
             setData({ img: images[prevIndex], i: prevIndex });
         }
         if(!action){
 
             setData({img: '', i: 0});
         }
     }
 
     useEffect(() => {
         const handleKeyDown = (event) => {
             console.log("Tecla pressionada:", event.key); // DEBUG
             if (data.img) {
                 if (event.key === "ArrowRight") {
                     console.log("Próxima imagem"); // DEBUG
                     imgAction("next-img");
                 } else if (event.key === "ArrowLeft") {
                     console.log("Imagem anterior"); // DEBUG
                     imgAction("previous-img");
                 } else if (event.key === "Escape") {
                     console.log("Fechando modal"); // DEBUG
                     imgAction();
                 }
             }
         };
 
         document.addEventListener("keydown", handleKeyDown);
         return () => document.removeEventListener("keydown", handleKeyDown);
     }, [data]); // Garante que sempre usa o estado mais atualizado

    return(
       
        <>
            {data.img &&
                <>
                    <div className='div-out'>
                        <img src={data.img} className='img-out' alt=''/>
                        <IconContext.Provider value={{ className: 'itprevious', color: 'white'}}>
                            <RiArrowLeftSLine 
                                onClick={() => imgAction('previous-img')}/>
                        </IconContext.Provider>
                        <IconContext.Provider value={{ className: 'it' }}>
                            <MdClose onClick={() => imgAction()}/>
                        </IconContext.Provider>
                        <IconContext.Provider value={{ className: 'itnext' }}>
                                <MdNavigateNext        
                                onClick={() => imgAction('next-img')}/>
                        </IconContext.Provider>
                    </div>
                </>
            }
            <div className='galllery-global'>
                 
                <ResponsiveMasonry 
                    columnsCountBreakPoints={{350: 1, 750: 2, 900:3}}>
                        <Masonry gutter='20px'>
                            {
                                images.map((image, i) => (
                                    <img 
                                        key={i}
                                        src={image}
                                        className='img-responsive'
                                        alt=""
                                        onClick={()=> viewImage(image, i)}
                                    />
                                ))
                            }
                        </Masonry>
                </ResponsiveMasonry>
                
            </div>
        </>
    );
}

export default GalleryPostoFriederichs;



